import React, { useEffect, useRef, Suspense, lazy } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './BannerPost.css';
 
const MediaFeaturesSection = lazy(() => import("../MediaFeaturesSection/MediaFeaturesSection"));

const BannerSection = ({   }) => {
 

  return (
    <div className="banner-section">
<div class="ussaic-banner">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-10 text-center">
        <img
          src="https://resources.swmc.com/ussaic/ussaicbanner.webp"
          alt="US Strategy for AI & Crypto"
          class="ussaic-logo"
        />
      
        {/* <h2 class="ussaic-subtitle">FOR AI & CRYPTO</h2> */}
        <p class="ussaic-heading">
          Uniting Policy and Business Leaders to Make America First in Ai and Crypto
        </p>
        <p class="ussaic-description">
          The US Strategy for AI & Crypto Summit brought together an extraordinary mix of policymakers,
          tech founders, regulatory experts, and thought leaders in the National Press Club in Washington,
          D.C. on July 8, 2025. Together, they shared bold visions and forged powerful strategies to make
          the U.S. a global leader in Artificial Intelligence and Cryptocurrency.
        </p>
      </div>
    </div>
  </div>
</div>

<div className="ussaic-event-highlight-carousel">
        <Suspense fallback={<div />}>
        <MediaFeaturesSection />
        </Suspense> 
        </div>

    </div>
  );
};

export default BannerSection;
